import { render } from "./MessagesTable.vue?vue&type=template&id=9b501d6c"
import script from "./MessagesTable.vue?vue&type=script&lang=js"
export * from "./MessagesTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/dschranka/actions-runner/_work/DSchranka/DSchranka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__